import { render, staticRenderFns } from "./TabServiceDetail.vue?vue&type=template&id=7ac3c54a"
import script from "./TabServiceDetail.vue?vue&type=script&lang=js"
export * from "./TabServiceDetail.vue?vue&type=script&lang=js"
import style0 from "./TabServiceDetail.vue?vue&type=style&index=0&id=7ac3c54a&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7ac3c54a')) {
      api.createRecord('7ac3c54a', component.options)
    } else {
      api.reload('7ac3c54a', component.options)
    }
    module.hot.accept("./TabServiceDetail.vue?vue&type=template&id=7ac3c54a", function () {
      api.rerender('7ac3c54a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/provider/billingHistory/components/tabs/TabServiceDetail.vue"
export default component.exports